const items = [
	{
		id: 1,
		name: "documentType.idCard",
	},
	// {
	// 	id: 2,
	// 	name: "documentType.passport",
	// },
	{
		id: 2,
		name: "documentType.familyBook",
	}
];

export default items;